module.exports = __webpack_public_path__ + "img/footer3.05764c88.png";